import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../tools/store";

const initialState: {
  currentPage: number;
  selectedItem: any;
  selectedSurah: any;
} = {
  currentPage: 1,
  selectedItem: {},
  selectedSurah: {},
};
export const NonPersistGlobalReducerName = "non_persist_global";

export const NonPersistGlobalSlice = createSlice({
  name: NonPersistGlobalReducerName,
  initialState,
  reducers: {
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    setSelected(state, action: PayloadAction<any>) {
      state.selectedItem = action.payload;
    },
    setSelectedSurah(state, action: PayloadAction<any>) {
      state.selectedSurah = action.payload;
    },
  },
});

export const { setCurrentPage, setSelected, setSelectedSurah } =
  NonPersistGlobalSlice.actions;

export const getCurrentPage = (state: RootState) =>
  state.non_persist_global.currentPage;

export const getSelectedItem = (state: RootState) =>
  state.non_persist_global.selectedItem;

export const getSelectedSurah = (state: RootState) =>
  state.non_persist_global.selectedSurah;

export default NonPersistGlobalSlice.reducer;
